namespace GeniuzPOS.ReportMasterData {
    export interface Report_1501Form {
    }

    export class Report_1501Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1501';
    }
}
